/* HerChoice.pk — Reels Carousel JS (thumbnail version) */
window.HCReels = (function () {

  function init(sectionId) {
    var track   = document.getElementById('hcReelsTrack-' + sectionId);
    var dotsEl  = document.getElementById('hcDots-' + sectionId);
    var prevBtn = document.getElementById('hcPrev-' + sectionId);
    var nextBtn = document.getElementById('hcNext-' + sectionId);
    if (!track) return;

    var cards     = track.querySelectorAll('.hc-reel-card');
    var cardCount = cards.length;
    var dots      = [];

    for (var i = 0; i < cardCount; i++) {
      var dot = document.createElement('button');
      dot.className = 'hc-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Go to reel ' + (i + 1));
      dot.dataset.index = i;
      dot.addEventListener('click', onDotClick);
      dotsEl.appendChild(dot);
      dots.push(dot);
    }

    track.addEventListener('scroll', onScroll, { passive: true });

    function onScroll() {
      var w   = cards[0].offsetWidth + 14;
      var idx = Math.max(0, Math.min(Math.round(track.scrollLeft / w), cardCount - 1));
      dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
      prevBtn.classList.toggle('hc-hidden', idx === 0);
      nextBtn.classList.toggle('hc-hidden', idx >= cardCount - 1);
    }

    prevBtn.addEventListener('click', function () {
      track.scrollLeft -= (cards[0].offsetWidth + 14) * 2;
    });
    nextBtn.addEventListener('click', function () {
      track.scrollLeft += (cards[0].offsetWidth + 14) * 2;
    });

    function onDotClick(e) {
      track.scrollLeft = (cards[0].offsetWidth + 14) * parseInt(e.currentTarget.dataset.index, 10);
    }

    prevBtn.classList.add('hc-hidden');
  }

  return { init: init };
})();
